<div class="not-found-container">
  <h2 class="not-found-title">Page Not Found</h2>
  <p class="not-found-message">Sorry, the page you are looking for doesn't exist.</p>
  <p class="redirect-message">You will be redirected to the homepage in a few seconds...</p>
</div>
